// extracted by mini-css-extract-plugin
module.exports = {"body":"WrapUpFMNoLongerNeeded_body__22haH"};